export enum AUTHOR_TYPES {
  BOT = "system-service",
  USER = "user",
  OPPONENT = "opponent",
}
